const utils = require('od-modules/xsell/utils');


function mytripsTraveller(traveller) {
    const that = {};

    that.getName = function() {
        return Odigeo._.get(traveller, 'name', '');
    };

    that.getLastName = function() {
        const firstLastName = Odigeo._.get(traveller, 'firstLastName', '');
        const secondLastName = Odigeo._.get(traveller, 'secondLastName', '');
        return `${firstLastName} ${secondLastName}`.trim();
    };

    that.getAgeType = function() {
        return traveller.travellerType;
    };

    that.getAge = function() {
        const timestamp = Odigeo._.get(traveller, 'dateOfBirth', 0);
        return utils.getAge(timestamp);
    };

    that.getIdentification = function() {
        return Odigeo._.get(traveller, 'identification', '');
    };

    that.getIdentificationType = function() {
        return Odigeo._.get(traveller, 'identificationType', '');
    };

    that.getCountryCodeOfResidence = function() {
        return Odigeo._.get(traveller, 'countryCodeOfResidence', '');
    };

    that.getBaggagesInArrival = function() {
        const baggagesInArrival = Odigeo._.get(traveller, 'baggages[0].baggageDescriptionList', []);
        return sumBaggages(baggagesInArrival);
    };

    that.getBaggagesInDeparture = function() {
        const baggagesInDeparture = Odigeo._.get(traveller, 'baggages[1].baggageDescriptionList', []);
        return sumBaggages(baggagesInDeparture);
    };

    return that;
}

function sumBaggages(baggages) {
    return Odigeo._.reduce(baggages, (accumulator, baggage) => accumulator + baggage.pieces, 0);
}

module.exports = mytripsTraveller;
